import { getHospitalName } from '@util/hospitalName'
import { useProfile as useProfileStore } from '@zustore/store'

/** Facility name for printed documents: the logged-in facility, else the deployment's configured hospital name. */
export const useFacilityDisplayName = (): string => {
  const { facility } = useProfileStore()
  const name = typeof facility?.name === 'string' ? facility.name.trim() : ''
  return name || getHospitalName()
}
